import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import { globales,funciones}                                        from '../../global';
import BarraBotones                                                 from '../../components/Barra_menu';
import AuthService                                                  from '../../AuthService';
import Request                                                      from 'superagent';
import CustomTable                                                  from '../../components/CustomTable';
import {Table,TableGroupRow}                                                      from '@devexpress/dx-react-grid-material-ui';
import TableRowsIndexer                                             from '../../components/tableRowsIndexer'
//import { Plugin, Template, TemplateConnector, TemplatePlaceholder } from "@devexpress/dx-react-core";
import Dialog                                                       from '@material-ui/core/Dialog';
import DialogContent                                                from '@material-ui/core/DialogContent';
import DialogTitle                                                  from '@material-ui/core/DialogTitle';
import CircularProgress                                             from '@material-ui/core/CircularProgress';
import Backdrop                                                     from '@material-ui/core/Backdrop';
import Icono                                                        from '../../components/Icono'
import {  Checkbox, IconButton,Typography,Paper }                  from '@material-ui/core';


let Auth = new AuthService();
var ip=globales.ip
var border_dialog=globales.border_dialog
//var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let isVisibleRowSelected = false;
//const colorRowSelected =  'rgb('+ colores.tabla.selection +')';
//let alternateColorRow1 = colores.tabla.alternateColorRow1; 
//let alternateColorRow2 = colores.tabla.alternateColorRow2;

const GroupCellContent = ({ column, row }) => {
    return ( 
            <span style={{color: column.name==='CARRERA'||column.name==='NIVEL'?'white':'inherit', background: column.name==='CARRERA'||column.name==='NIVEL'?'#00336A':'inherit'}}>    
             <strong>{column.name==='PERIODO'?'Período: ':''}</ strong>
             {column.name==='CARRERA'||column.name==='NIVEL'?
             <b>{row.value}</b>
             :row.value
              }
            </span>
            );
}

const tableGroupRow_cellComponent= (props) => {
  return (
    <TableGroupRow.Cell  {...props} style={{background: props.column.name==='Cursos'||props.column.name==='CARRERA'||props.column.name==='NIVEL'?'#00336A':'inherit'}}/>
 );
}

const groupIconComponent= (props) => {
  return (
    <TableGroupRow.Icon  {...props} style={{ width: 22, height: 22, padding: 0,background:'white',color: 'inherit' }}/>
 );
}


const getRowId = row => row.ID_DETALLE_PLAN;


/*                           CLASES DE ESTILO                       */

var styles = theme =>({
    Dialog:{
        borderRadius: border_dialog,
        margin:0,
        padding:0
    },
    backdrop: {
      zIndex: 500000,
      color: '#fff', 
      flexDirection: 'column'
    },
    select: { //CONFIGURA EL SELECT 
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'50%',
      },
      textField: {
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'20%',
        width: '20%'      
      },
    })

    const columns= [{name:'ID_DETALLE_PLAN',title: 'ID_DETALLE_PLAN'},
    {name:'DESCRIPCION_CARRERA',title: ' '},
    {name:'DESCRIPCION_NIVEL',title: 'Nivel'},
    {name:'PERIODO',title: 'Periodo'},
    {name:'CARRERA',title: 'CARRERA'},
    {name:'NIVEL',title: 'NIVEL'},
    {name:'CODIGO_CURSO',title: 'Código'},
    {name:'DESCRIPCION_CURSO',title: 'Descripción'},
    {name:'CREDITOS',title: 'U.V.'},
    {name:'SUFICIENCIA',title: 'Suficiencia'},
    {name:'OPTATIVA',title: 'Electiva'},
    {name:'BOTON',title: 'Requisitos'},
    {name:'REQUISITOS',title: 'REQUISITOS'},
    ];

    const defaultHiddenColumnNames= ['ID_DETALLE_PLAN','REQUISITOS'];

    const tableColumnExtensions= [
        { columnName: 'CODIGO_CURSO', wordWrapEnabled: false, align: 'left',width:100},
        { columnName: 'DESCRIPCION_CURSO', wordWrapEnabled: false, align: 'left',width:400},
        { columnName: 'CREDITOS', wordWrapEnabled: false, align: 'center',width:80},
        { columnName: 'SUFICIENCIA', wordWrapEnabled: false, align: 'center',width:100},
        { columnName: 'OPTATIVA', wordWrapEnabled: false, align: 'center',width:100},
        { columnName: 'BOTON', wordWrapEnabled: false, align: 'center',width:80},
    ];

    const grouping= [{ columnName: 'CARRERA' },{ columnName: 'DESCRIPCION_CARRERA' },{ columnName: 'NIVEL' },{ columnName: 'DESCRIPCION_NIVEL' },{ columnName: 'PERIODO' }]

/*                                        EXPORT                                      */
export default withStyles(styles)(
    class Carreras_Alumno extends React.Component {
      tablaRef = React.createRef();

      constructor(props) {
        super(props);
        this.l= props.l
        this.e= props.e
        this.i= props.i
        this.isVisibleRowSelected=isVisibleRowSelected
        this.actualizarbarra=props.actualizarbarra
        this.actualizarcircular=props.actualizarcircular

        this.state = {
            openBackDrop:      false, 
            isLoggin:          undefined,
            heightTableMain:    0,
            rows: [],
            selection: [],
            grouping: [],
            expandedGroups: [],
            filteringColumnExtensions: [],
            filters: [],
            expandedRowIds: [],
            enabledFilterRows: false,
            open_requisitos:  false,
            requisitos:       ""
        }

        /*const trow = TableRow => withStyles(styles, { name: "Row" })( ({classes,highlighted, rowIndex, row, selectByRowClick, ...props}) => {
            const odd = !!(rowIndex % 2);
            const r = props.tableRow 
                    
            if (this.state.selection[0] === props.tableRow.row.ID_ROL) { isVisibleRowSelected = true; }
               return (
                   <Table.Row {...props}
                     //onClick={clickselection(r.row.ID_ROL,r.row.CODIGO,r.row.NOMBRE,r.row.DESCRIPCION,r.row.USUARIOS,r.row.PERMISOS)}
                   style={{
                       cursor: 'pointer',
                        //backgroundColor: r.row.GRUPO_OPTATIVA==='Cursos'?'blue':'inherit',                 
                       padding: '0rem 0rem !important',margin: '0px',                 
                     }}
                   />
                 );
           });*/

           
const VirtualTable_cellComponent = (props) => {
  const { column }    = props;
  const {row}         = props;

  const ClickBoton=(REQUISITOS) => event =>{
    var requisitos_array=REQUISITOS.split('/n')
    var requisitos_comp

    requisitos_comp=requisitos_array.map((item,index)=>{
    var contenido=item.split('_');

      if(index>0 && item!=='')
      return(
        <Paper key={"Pa-"+item} elevation={3} style={{padding:10,marginBottom:5 }}>
        <b>{contenido[0]}</b>
        {' - '+contenido[1]}
        </Paper>
      )
      
      if(index===0 && item!=='')
      return(
        <Paper key={"Pa-"+item} elevation={3} style={{padding:10,marginBottom:5 }}>
        <b>{contenido[0]}</b>
        {' - '+contenido[1]}
        </Paper>
      );
      return null;
    })

    this.setState({open_requisitos: true,requisitos:requisitos_comp })
  }

  if(column.name==='SUFICIENCIA')
  {
    return(
      <Table.Cell {...props} style={{padding:0}}>
        <Checkbox checked={row.SUFICIENCIA}/>
      </Table.Cell>
    );
  }
  if(column.name==='OPTATIVA')
  {
    return(
      <Table.Cell {...props} style={{padding:0}}>
        <Checkbox checked={row.OPTATIVA} />
      </Table.Cell>
    );
  }
  if(column.name==='BOTON' && row.REQUISITOS!==null)
  {
    return(
      <Table.Cell {...props} style={{padding:0}}>
        <IconButton onClick={ClickBoton(row.REQUISITOS)} >
          <Icono icono='List' />
        </IconButton>
      </Table.Cell>
    );
  }

  return(
      <Table.Cell {...props} style={{padding:0}}/>
    );
}

           //this.trow = trow(Table.Row);
           this.VirtualTable_cellComponent = VirtualTable_cellComponent;
        
}; //FIN CONSTRUCTORS


componentDidMount()
{
        let _this = this;
        _this.actualizarbarra(false)

        Auth.loggedIn().then( function(b){
            _this.setState({ isLoggin: b})
            if(b)
            Request.get(`${ip}/carrerasalumno/obtener_carreras_alumno/${Auth.getProfile().user}`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .retry(1)
            .timeout({ response: 20000, deadline: 50000, }) 
            .end((err, res)=> {
             if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      return;  
                    }
                    (async function() {
                        funciones.showToast('e','Error de conexión')
                    })();//FIN FUNCION ASYNC
                    return;
            }
            const tmp = JSON.parse(res.text);
            if(tmp.length>0){
                   var arr=[] 
                   arr.push(tmp[0].CARRERA)
                    _this.setState({ rows: tmp, expandedGroups:arr,heightTableMain: funciones.getHeightTableMain(movil_pequeño,_this).heightTable
                    }); 
                }
                else
                {
                    _this.setState({rows: [], heightTableMain:   funciones.getHeightTableMain(movil_pequeño,_this).heightTable})
                }
            _this.actualizarbarra(true)
        })
    })
}

changeExpandedGroups = expandedGroups =>
{
    this.setState({ expandedGroups });
};

cerrarmodal =()=> event =>{
  this.setState({open_requisitos: false })
}

/*                                          RENDER                          */
render() {
    const { classes } = this.props;

    const botones_requisitos = [
      {icono: 'Close',  nombre: 'Cerrar' ,onclick: this.cerrarmodal(), display:'auto', color: 'red'},
    ]

    if (this.state.isLoggin === true )
    {
    return (    
    <React.Fragment>
      <Backdrop className={classes.backdrop}  open={this.state.openBackDrop}>
          <CircularProgress color="inherit" />
          <span style={{ marginTop: '10px' }}>{this.state.open_seleccion?'Guardando...':this.state.open_borrar?'Eliminando...':''}</span>
      </Backdrop>

      {/*--------------------------------------------------------------------------- DIALOG REQUISITOS --------------------------------------------------------------------*/}
      
      <Dialog open={this.state.open_requisitos}  //onClose={this.cerrarmodal()} 
      fullWidth={true} maxWidth='xs'
      fullScreen={movil_pequeño?true:false}
      //onEntering={this.onEntering}
      TransitionProps={{ onEntering: this.onEntering }}
      >
      <DialogTitle>
        <Typography component='span'  variant='subtitle2'>
          {'Requisitos'}
        </Typography>
      </DialogTitle>
      <DialogContent>
      <div style={{height:'300px'}}>
        {this.state.requisitos}
      </div>
      </DialogContent>
        <BarraBotones botones={botones_requisitos} backgroundColor='white' l={this.l} e={this.e} i={this.i}/>
      </Dialog>

    {/*--------------------------------------------------------------------------------------------------------------------------------------------------------------------*/}

      <div ref={this.tablaRef} style={{background:'white',marginLeft:movil_pequeño?globales.tabla.marginleft_movil:globales.tabla.marginleft,marginRight:movil_pequeño?globales.tabla.marginright_movil:globales.tabla.marginright}}>
      <CustomTable
            Columns={columns}                                    
            Rows={this.state.rows}                                          
            TableColumnExtensions={tableColumnExtensions}
            DefaultHiddenColumnNames={defaultHiddenColumnNames}
            getRowId = {getRowId}
            height={this.state.heightTableMain}
            Grouping={grouping} 
            ChangeExpandedGroups = {this.changeExpandedGroups}
            //Filters = {this.state.filters}
            //onFiltersChange = {this.changeFilters}
            ExpandedGroups = {this.state.expandedGroups}
            //ExpandedRowIds = {this.state.expandedRowIds}
            enabledFilterRows= {this.state.enabledFilterRows}
            groupContentComponent={GroupCellContent}
            tableGroupRow_cellComponent={tableGroupRow_cellComponent}
            groupIconComponent={groupIconComponent}
            standarPlugin = { <TableRowsIndexer/> }
            //RowComponent={this.trow}
            VirtualTable_cellComponent={this.VirtualTable_cellComponent}
            //rowHeaderCellComponent={TableTreeColumnHeader_cellComponent}
            showSelectionColumn={false}
        />
      </div>
    </React.Fragment>
    ); /// finaliza return
    }
    else if (this.state.isLoggin === false)
    {
        Auth.logout()
        window.location.reload();
        return; 
    }


    return null;
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles

    

    